// @flow
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.SURCHARGES_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getTotalNoSurcharges = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_count';
    return makeApiCall(endpoint, query);
};

const getTotalNoNonShipmentSurcharges = (query: Query | string): Promise<any> => {
    const endpoint = '/non_shipment_surcharges_count';
    return makeApiCall(endpoint, query);
};

const getTotalSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/total_surcharges_cost';
    return makeApiCall(endpoint, query);
};

const getTotalNonShipmentSurchargesCost = (query: Query | string): Promise<any> => {
    const endpoint = '/total_non_shipment_surcharges_cost';
    return makeApiCall(endpoint, query);
};

const getSurchargeSummary = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_details';
    return makeApiCall(endpoint, query);
};

const getNonShipmentSurchargeSummary = (query: Query | string): Promise<any> => {
    const endpoint = '/non_shipment_surcharges_details';
    return makeApiCall(endpoint, query);
};

const getSurchargesByTimeframe = (query: Query | string): Promise<any> => {
    const endpoint = '/surcharges_by_timeframe';
    return makeApiCall(endpoint, query);
};

export {
    getTotalNoSurcharges,
    getTotalNoNonShipmentSurcharges,
    getTotalSurchargesCost,
    getTotalNonShipmentSurchargesCost,
    getSurchargeSummary,
    getNonShipmentSurchargeSummary,
    getSurchargesByTimeframe,
};
